import React, { useState } from "react";
import {
  BaseEdge,
  EdgeLabelRenderer,
  EdgeProps,
getSmoothStepPath,
  useReactFlow,
} from "reactflow";

import "../Node_Edge_Components.css";

const CustomEdge=({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {position: 'relative',strokeDasharray: '0,0',},
  markerEnd,
  label,
})=>{
  const { setEdges } = useReactFlow();
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const onEdgeClick = () => {
    setEdges((edges) => edges.filter((edge) => edge.id !== id));

  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer >
      <div
    style={{
        position: 'absolute',
        transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
        fontSize: 10,
        pointerEvents: 'all',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    
    }}
    className="edgeContainer"
>
<p style={{  paddingBottom:'15px'}}>{label}</p>
    <div className="buttonContainer">

        <button className="edgebutton" onClick={onEdgeClick}>
            ×
        </button>
    </div>
</div>

      </EdgeLabelRenderer>
  
  </>
  
  );
}
export default CustomEdge